import styles from './LoaderIndicator.module.css';

const LoaderIndicator = () => {
    return <div className={styles.content}></div>;
};

export default LoaderIndicator;
